'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = scatter;

var _react = require('react');

var _splitHandlers2 = require('../helpers/split-handlers');

var _splitHandlers3 = _interopRequireDefault(_splitHandlers2);

var _adapterType = require('../adapters/adapter-type');

var _adapterType2 = _interopRequireDefault(_adapterType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function scatter(_ref) {
  var name = _ref.name,
      _ref$contextTypes = _ref.contextTypes,
      contextTypes = _ref$contextTypes === undefined ? {} : _ref$contextTypes;

  var update = function update(component, props, context) {
    var _splitHandlers = (0, _splitHandlers3.default)(props),
        data = _splitHandlers.data,
        handlers = _splitHandlers.handlers;

    var scatterer = context.entanglement.scatterer;

    var handlerNames = Object.keys(handlers);

    // dismiss previous handlers and register new ones
    component.dismissers = component.dismissers || [];
    component.dismissers.forEach(function (dismisser) {
      return dismisser();
    });
    component.dismissers = handlerNames.map(function (handlerName) {
      return scatterer.addHandlerListener(name, handlerName, function (args) {
        return handlers[handlerName].apply(component, args);
      });
    });

    scatterer.render(name, data, handlerNames, extractContext(context, contextTypes));
  };

  var unmount = function unmount(component) {
    var scatterer = component.context.entanglement.scatterer;


    scatterer.unmount(name);
    component.dismissers.forEach(function (dismisser) {
      return dismisser();
    });
    component.dismissers = [];
  };

  var validate = function validate(component) {
    // only do it if NODE_ENV !== production
    // validate if there is a entanglement in the context
    // validate that the props should only have a shallow handlers
  };

  var Scatter = function (_Component) {
    _inherits(Scatter, _Component);

    function Scatter(props, context) {
      _classCallCheck(this, Scatter);

      var _this = _possibleConstructorReturn(this, (Scatter.__proto__ || Object.getPrototypeOf(Scatter)).call(this, props, context));

      update(_this, props, context);
      return _this;
    }

    _createClass(Scatter, [{
      key: 'componentWillUpdate',
      value: function componentWillUpdate(nextProps) {
        validate(this);

        update(this, nextProps, this.context);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        unmount(this);
      }

      // the wrapped component will not be rendered here

    }, {
      key: 'render',
      value: function render() {
        return false;
      }
    }]);

    return Scatter;
  }(_react.Component);

  Scatter.displayName = 'Entanglement.scatter.' + name;

  Scatter.contextTypes = _extends({
    entanglement: _adapterType2.default
  }, contextTypes);

  return Scatter;
}

function extractContext(context, contextTypes) {
  return Object.keys(contextTypes).reduce(function (acc, key) {
    return _extends({}, acc, _defineProperty({}, key, context[key]));
  }, {});
}